"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle() {
  return {
    Form: {
      margin: 0,
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map